<!-- 组件说明 -->
<template>
  <component :is="componentsMap[item.type]" :data="item" class="component" />
</template>

<script>
import GoodsList from '../components/GoodsList';
import Slider from '../components/Slider';
import RichText from '../components/RichText';

const components = {
  GoodsList,
  Slider,
  RichText,
};

const map = Object.keys(components).reduce((map, name) => {
  name = name.replace(name[0], name[0].toLowerCase());
  map[name] = name;
  return map;
}, {});
export default {
  components,
  props: ['item'],
  data() {
    return {
      componentsMap: map,
    };
  },
  created() {
    //生命周期 - 创建完成
  },
};
</script>
<style lang='scss' scoped>
</style>


// WEBPACK FOOTER //
// src/pages/index/common/ComponentLoader.vue